'use strict';


export default function() {
	return {
		compile: compile,
	};

	// Some modifications need to be done during compilation, such as adding
	// directives like ui-mask.
	function compile(tElement, tAttrs) {
		switch(tAttrs.type) {
			case 'tel':
				tAttrs.$set('ui-mask', '(999) 999-9999');
				break;
		}
	}
}
